import React, {FC, Fragment, useMemo, useState} from 'react';

import {usePushEvent} from '../../../../../libs/shared/core/src/services/push/pushContext';
import {PushEventTypesEnum} from '../../../../../srcCommon/push/pushHelpers';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {
  AiTaggingSampleApprovedModel,
  ApiAiTaggingSampleApproved,
} from '../../../../models/api/aiTaggingSampleApprovedModel';
import {getAiTaggingHarvestingJobs} from '../../../../store/data/jobs/jobsSelectors';
import {AiTaggingSampleApprovedBanner} from '../../../push/aiTaggingSampleApprovedBanner';
import {AiReviewConversationsHarvestingBanner} from './aiReviewConversationsHarvestingBanner';

/*
 * Props.
 */

interface AiTaggingBannersProps {}

/*
 * Component.
 */

export const AiTaggingBanners: FC<AiTaggingBannersProps> = () => {
  const jobs = useAppSelector(getAiTaggingHarvestingJobs);
  const [dismissedJobIds, setDismissedJobIds] = useState<ReadonlyArray<number>>([]);
  const [aiTaggingSampleApproved, setAiTaggingSampleApproved] = useState<
    AiTaggingSampleApprovedModel | undefined
  >();

  /*
   * Event handlers.
   */

  const onAiTaggingApprovedDismiss = () => {
    // Close the banner.
    setAiTaggingSampleApproved(undefined);
  };

  const onAiTaggingHarvestingJobDismiss = (jobId: number) => {
    setDismissedJobIds((jobIds) => [...jobIds, jobId]);
  };

  usePushEvent(PushEventTypesEnum.AI_TAGGING_SAMPLE_APPROVED, ApiAiTaggingSampleApproved, (approvedEvent) =>
    setAiTaggingSampleApproved(approvedEvent),
  );

  /*
   * Render.
   */

  const visibleJobs = useMemo(
    () => jobs.filter((j) => !dismissedJobIds.includes(j.id)),
    [jobs, dismissedJobIds],
  );

  return (
    <>
      {visibleJobs.map((job) => (
        <Fragment key={job.id}>
          {
            <AiReviewConversationsHarvestingBanner
              job={job}
              onDismissClick={onAiTaggingHarvestingJobDismiss}
            />
          }
        </Fragment>
      ))}

      {/* Approved notification banners */}
      {aiTaggingSampleApproved && (
        <AiTaggingSampleApprovedBanner
          aiTaggingSampleApprovedModel={aiTaggingSampleApproved}
          onDismissClick={onAiTaggingApprovedDismiss}
        />
      )}
    </>
  );
};
